import {Component, Input} from '@angular/core';
import {CompanyImageResponse, CompanyResponse} from '../../../../../../@shared/models/response.module';
import {_COR_COY_6, _COR_COY_7} from '../../../../../../@shared/models/input.module';
import {CompanyService} from '../../../../../../@shared/services/company.service';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastService} from '../../../../../../@core/services/toast.service';
import {TranslateService} from '@ngx-translate/core';
import {DeleteModal} from '../../../../../../@shared/components/delete-modal/delete-modal';

@Component({
  selector: 'app-edit-company-images',
  standalone: false,
  templateUrl: './edit-company-images.html',
  styleUrl: './edit-company-images.css'
})
export class EditCompanyImages {
  @Input() company: CompanyResponse
  companyImages: CompanyImageResponse[] = [];
  files: File[] = [];
  deletingImageId: number | null = null;

  constructor(
    private companyService: CompanyService,
    public modal: NgbActiveModal,
    private modalService: NgbModal,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.getCompanyImages();
  }

  getCompanyImages() {
    this.companyService.getCompanyImages({}).subscribe((res) => {
      this.companyImages = res;
    })
  }

  onFilesChanged(files: File[]) {
    console.log("Selected Files: ", files);
    this.files = files;
  }

  uploadImages() {
    if (this.files.length === 0) {
      this.modal.close(false);
      return;
    }

    let uploadedCount = 0;
    const totalFiles = this.files.length;

    for (const file of this.files) {
      const payload: _COR_COY_6 = {
        image: file
      };

      this.companyService.postCompanyImage(payload).subscribe({
        next: (res) => {
          this.companyImages.push(res);
          uploadedCount++;

          if (uploadedCount === totalFiles) {
            this.toastService.success(this.translateService.instant('companyImages.uploadSuccess'));
            this.files = [];
            this.modal.close(true);
          }
        },
        error: () => {
          this.toastService.error(this.translateService.instant('companyImages.uploadError'));
        }
      });
    }
  }

  deleteImage(image: CompanyImageResponse) {
    const modalRef = this.modalService.open(DeleteModal, {centered: true});
    modalRef.componentInstance.title = this.translateService.instant('companyImages.deleteTitle');
    modalRef.componentInstance.message = this.translateService.instant('companyImages.deleteMessage');

    modalRef.result.then((confirmed) => {
      if (confirmed) {
        this.confirmDeleteImage(image);
      }
    }).catch(() => {
      // Modal dismissed
    });
  }

  private confirmDeleteImage(image: CompanyImageResponse) {
    this.deletingImageId = image.image_id;

    const payload: _COR_COY_7 = {
      image_id: image.image_id
    };

    this.companyService.deleteCompanyImage(payload).subscribe({
      next: () => {
        // Remove image from array immediately for instant UI update
        this.companyImages = this.companyImages.filter(img => img.image_id !== image.image_id);
        this.deletingImageId = null;
        this.toastService.success(this.translateService.instant('companyImages.deleteSuccess'));
      },
      error: () => {
        this.deletingImageId = null;
        this.toastService.error(this.translateService.instant('companyImages.deleteError'));
      }
    });
  }
}
